"use client";
import { useState, Suspense } from "react";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";

function LoginForm() {
  const params = useSearchParams();
  const next = params.get("next") ?? "/";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null);
    const r = await signIn("credentials", { email, password, redirect: false });
    setBusy(false);
    if (!r || r.error) { setError("Invalid email or password"); return; }
    window.location.href = next;
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <form onSubmit={submit} className="bg-white rounded-lg shadow-md w-full max-w-sm p-6 space-y-4">
        <h1 className="text-xl font-semibold text-center">Auto Lift Parts — KB</h1>
        <p className="text-center text-sm text-slate-500">Sign in</p>
        <label className="block text-sm">
          <span>Email</span>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus
                 className="block w-full mt-1 border border-slate-300 rounded px-3 py-2" />
        </label>
        <label className="block text-sm">
          <span>Password</span>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                 className="block w-full mt-1 border border-slate-300 rounded px-3 py-2" />
        </label>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        <button type="submit" disabled={busy} className="w-full bg-slate-900 text-white rounded py-2 cursor-pointer hover:bg-slate-800 disabled:opacity-50">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}

export default function LoginPage() {
  return <Suspense fallback={<div />}><LoginForm /></Suspense>;
}
